import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';
import { PlanRegion }  from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/source` : l'aperçu du plan ENTIER, sur lequel
 * l'opérateur trace sa zone d'analyse.
 *
 * Lecture ET écriture, comme `/plan/glyphs` : sans `analysisRegion` l'appel ne fait que
 * rendre l'image, avec elle enregistre la zone puis rend l'image à jour.
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { analysisRegion } })`.
 *
 * L'image est auto-portée (data-URI) : l'image source pour un raster ou un PDF scanné, le
 * rendu de tous les calques réunis pour un vectoriel. Elle ne dépend d'AUCUN mapping —
 * c'est justement le mapping que la zone sert à assainir.
 */
@doc.path('/imports/{id}/plan/source')
export default class PlanSourceModel extends MapServiceModel {
	@doc.string declare imageDataUri: string;
	@doc.number declare width: number;
	@doc.number declare height: number;
	@doc.json   declare analysisRegion: PlanRegion | null;
}
